import Index from '@tunnel-components/@pages/login/container'

/**
 * @export Container
 */

export default Index



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@pages/login/index.ts